module.exports = __webpack_public_path__ + "img/電気回路_5_10_1.f764275d.png";